export const leaveConfigConstants = {
    GET_CONFIG_LIST_SUCCESS: "GET_CONFIG_LIST_SUCCESS",
    UPDATE_CONFIG_LIST: "UPDATE_CONFIG_LIST",
    UPDATE_CONFIG_LIST_SUCCESS: "UPDATE_CONFIG_LIST_SUCCESS",
    UPDATE_CONFIG_LIST_FAIL: "UPDATE_CONFIG_LIST_FAIL",
    CLEAR_MESSAGE: "CLEAR_MESSAGE",
};

export const renewDayOption = {
    0: "01-01",
    1: "01-04",
};
